import React from 'react';

// Shared visual treatment for a paid feature a merchant can't use yet: the control
// stays visible but greyed out with a short upgrade hint beneath it.
const ACCENT = '#F15A29';

export const lockedControlStyle = {
  opacity: 0.45,
  filter: 'grayscale(1)',
  pointerEvents: 'none',
};

export const UpgradeHint = ({ label = 'Upgrade to access this feature', style = {} }) => (
  <div style={{ fontSize: 12, color: ACCENT, fontWeight: 600, marginTop: 4, ...style }}>
    🔒 {label}
  </div>
);
